// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/store_coupon/v1/store_coupon.proto (package fingertip.creator.store_coupon.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Int32Value, proto3, StringValue, Timestamp } from "@bufbuild/protobuf";
import { StoreCoupon } from "../../../common/type/v1/store_coupon_pb.js";
import { StoreCouponDiscount } from "../../../common/type/v1/store_coupon_discount_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { StoreDiscountType } from "../../../common/enum/v1/store_discount_type_pb.js";
import { StoreDiscountValueType } from "../../../common/enum/v1/store_discount_value_type_pb.js";

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponPublicRequest
 */
export const ApplyStoreCouponPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponPublicResponse
 */
export const ApplyStoreCouponPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponToBookingPublicRequest
 */
export const ApplyStoreCouponToBookingPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponToBookingPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponToBookingPublicResponse
 */
export const ApplyStoreCouponToBookingPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponToBookingPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponToAttendancePublicRequest
 */
export const ApplyStoreCouponToAttendancePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponToAttendancePublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.ApplyStoreCouponToAttendancePublicResponse
 */
export const ApplyStoreCouponToAttendancePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.ApplyStoreCouponToAttendancePublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.RemoveStoreCouponPublicRequest
 */
export const RemoveStoreCouponPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.RemoveStoreCouponPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.RemoveStoreCouponPublicResponse
 */
export const RemoveStoreCouponPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.RemoveStoreCouponPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponRequest
 */
export const GetStoreCouponRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponRequest",
  () => [
    { no: 1, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponResponse
 */
export const GetStoreCouponResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponResponse",
  () => [
    { no: 1, name: "coupon", kind: "message", T: StoreCoupon },
    { no: 2, name: "coupon_discounts", kind: "message", T: StoreCouponDiscount, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponPublicRequest
 */
export const GetStoreCouponPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponPublicResponse
 */
export const GetStoreCouponPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponPublicResponse",
  () => [
    { no: 1, name: "coupon", kind: "message", T: StoreCoupon },
    { no: 2, name: "coupon_discounts", kind: "message", T: StoreCouponDiscount, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponsRequest
 */
export const GetStoreCouponsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponsItem
 */
export const GetStoreCouponsItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponsItem",
  () => [
    { no: 1, name: "coupon", kind: "message", T: StoreCoupon },
    { no: 2, name: "coupon_discounts", kind: "message", T: StoreCouponDiscount, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.GetStoreCouponsResponse
 */
export const GetStoreCouponsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.GetStoreCouponsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetStoreCouponsItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.CouponDiscount
 */
export const CouponDiscount = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.CouponDiscount",
  () => [
    { no: 1, name: "coupon_discount_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(StoreDiscountType) },
    { no: 3, name: "value_type", kind: "enum", T: proto3.getEnumType(StoreDiscountValueType) },
    { no: 4, name: "value_fixed_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "value_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "total_min_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "discount_max_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "price_min_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "quantity_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "quantity_max", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.CreateStoreCouponRequest
 */
export const CreateStoreCouponRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.CreateStoreCouponRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "coupon_discounts", kind: "message", T: CouponDiscount, repeated: true },
    { no: 5, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "expires_at", kind: "message", T: Timestamp },
    { no: 7, name: "valid_at", kind: "message", T: Timestamp },
    { no: 8, name: "limit_contact_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "limit_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.CreateStoreCouponResponse
 */
export const CreateStoreCouponResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.CreateStoreCouponResponse",
  () => [
    { no: 1, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.UpdateStoreCouponRequest
 */
export const UpdateStoreCouponRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.UpdateStoreCouponRequest",
  () => [
    { no: 1, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "message", T: StringValue },
    { no: 4, name: "coupon_discounts", kind: "message", T: CouponDiscount, repeated: true },
    { no: 5, name: "expires_at", kind: "message", T: Timestamp },
    { no: 6, name: "valid_at", kind: "message", T: Timestamp },
    { no: 7, name: "limit_contact_uses", kind: "message", T: Int32Value },
    { no: 8, name: "limit_uses", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.UpdateStoreCouponResponse
 */
export const UpdateStoreCouponResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.UpdateStoreCouponResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.DeleteStoreCouponRequest
 */
export const DeleteStoreCouponRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.DeleteStoreCouponRequest",
  () => [
    { no: 1, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_coupon.v1.DeleteStoreCouponResponse
 */
export const DeleteStoreCouponResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_coupon.v1.DeleteStoreCouponResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

